/* Rekover : système de mouvement unique (v25).
   API Web Animations + IntersectionObserver ; Motion (motion.dev) seulement pour les effets liés au scroll.
   Tout est désactivé si l'utilisateur demande moins d'animations. */
(function () {
  'use strict';
  var d = document, html = d.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var EASE = { out: 'cubic-bezier(.16,1,.3,1)', inout: 'cubic-bezier(.76,0,.24,1)', std: 'cubic-bezier(.2,.7,.2,1)' };
  var DUR = { fast: 240, normal: 560, slow: 950 };
  var lang = (html.lang || 'fr').slice(0, 2);
  var TXT = {
    added: { fr: 'Ajouté au panier', en: 'Added to cart', nl: 'Toegevoegd' }[lang] || 'Ajouté au panier'
  };
  function mobile() { return window.innerWidth < 750; }
  function dur(k) { return Math.round(DUR[k] * (mobile() ? 0.8 : 1)); }
  function play(el, frames, opts) {
    if (!el || !el.animate) return null;
    var o = { duration: dur('normal'), easing: EASE.out, fill: 'backwards' };
    for (var k in opts) o[k] = opts[k];
    return el.animate(frames, o);
  }
  function $$(sel, root) { return Array.prototype.slice.call((root || d).querySelectorAll(sel)); }

  /* ---------- 1. Arrivée sur l'accueil ---------- */
  function heroIntro() {
    var intro = d.querySelector('[data-h24-intro]');
    var stage = d.querySelector('[data-h24-stage]');
    var hint = d.querySelector('[data-h24-hint]');
    html.classList.remove('rk-pre');
    if (!intro || reduce) return;
    var kicker = intro.querySelector('.h24__kicker'), big = intro.querySelector('.h24__big'), lead = intro.querySelector('.h24__lead');
    play(stage, [{ opacity: 0, transform: 'scale(1.04)' }, { opacity: 1, transform: 'none' }], { duration: 1200, delay: 60 });
    play(kicker, [{ opacity: 0, transform: 'translateY(12px)' }, { opacity: 1, transform: 'none' }], { duration: dur('normal'), delay: 180 });
    play(big, [{ clipPath: 'inset(0 0 100% 0)', transform: 'translateY(32px)' }, { clipPath: 'inset(0 0 -10% 0)', transform: 'none' }], { duration: dur('slow') + 100, delay: 280 });
    play(lead, [{ opacity: 0, transform: 'translateY(16px)' }, { opacity: 1, transform: 'none' }], { duration: dur('normal'), delay: 520 });
    play(hint, [{ opacity: 0 }, { opacity: 1 }], { duration: dur('normal'), delay: 900 });
  }

  /* ---------- 2. Apparitions au défilement (une seule fois) ---------- */
  var io = null;
  var REVEAL = {
    fade: function (el, delay) { return play(el, [{ opacity: 0, transform: 'translateY(' + (mobile() ? 16 : 26) + 'px)' }, { opacity: 1, transform: 'none' }], { delay: delay }); },
    soft: function (el, delay) { return play(el, [{ opacity: 0 }, { opacity: 1 }], { delay: delay, duration: dur('normal') }); },
    clip: function (el, delay) { return play(el, [{ clipPath: 'inset(0 0 100% 0)', transform: 'translateY(.3em)' }, { clipPath: 'inset(0 0 -12% 0)', transform: 'none' }], { delay: delay, duration: dur('slow') }); },
    image: function (el, delay) {
      var img = el.querySelector('img');
      if (img) play(img, [{ transform: 'scale(1.06)' }, { transform: 'scale(1)' }], { delay: delay, duration: dur('slow') + 300 });
      return play(el, [{ clipPath: 'inset(100% 0 0 0)' }, { clipPath: 'inset(0% 0 0 0)' }], { delay: delay, duration: dur('slow') + 100, easing: EASE.inout });
    }
  };
  function mark(el, type, delay) {
    if (!el || el.dataset.rk) return;
    el.dataset.rk = type; el.dataset.rkDelay = delay || 0;
    el.classList.add('rk-hide', 'rk-hide--' + type);
    // Un élément masqué par clip-path n'a plus de surface visible : on observe son parent
    var watch = (type === 'clip' || type === 'image') && el.parentElement ? el.parentElement : el;
    (watch._rk = watch._rk || []).push(el);
    io.observe(watch);
  }
  function scanReveals(root) {
    if (reduce || !('IntersectionObserver' in window)) return;
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          io.unobserve(e.target);
          (e.target._rk || []).forEach(function (el) {
            el.classList.remove('rk-hide', 'rk-hide--' + el.dataset.rk);
            REVEAL[el.dataset.rk](el, +el.dataset.rkDelay || 0);
          });
          e.target._rk = null;
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    }
    // En-têtes de section : surtitre -> titre -> texte, en léger décalé
    $$('main .section-head', root).forEach(function (head) {
      if (head.closest('.h24')) return;
      mark(head.querySelector('.eyebrow'), 'soft', 0);
      mark(head.querySelector('.h2, .h1'), 'clip', 90);
      mark(head.querySelector('.section-head__text'), 'fade', 220);
    });
    // Titres isolés (hors en-tête de section)
    $$('main .h2, main .spotlight__title', root).forEach(function (h) {
      if (h.closest('.section-head') || h.closest('.h24') || h.closest('.cd')) return;
      mark(h, 'clip', 0);
    });
    // Collections : la grande image se dévoile, les autres arrivent en fondu décalé
    $$('main .bento', root).forEach(function (grid) {
      $$('.bento__card', grid).forEach(function (card, i) {
        if (card.classList.contains('bento__card--large')) mark(card.querySelector('.bento__media'), 'image', 0);
        mark(card, 'fade', 60 + i * 70);
      });
    });
    // Produit phare : image éditoriale dévoilée
    $$('main .spotlight__main', root).forEach(function (m) { mark(m, 'image', 0); });
  }

  /* ---------- 3. Manifeste : les mots s'allument au fil du scroll ---------- */
  function initStatements(root) {
    $$('[data-statement]', root).forEach(function (sec) {
      var p = sec.querySelector('[data-statement-text]');
      if (!p || p.dataset.ready) return;
      p.dataset.ready = '1';
      var text = p.textContent.trim();
      var sr = d.createElement('span'); sr.className = 'visually-hidden'; sr.textContent = text;
      var vis = d.createElement('span'); vis.setAttribute('aria-hidden', 'true');
      text.split(/\s+/).forEach(function (w, i, arr) {
        var s = d.createElement('span'); s.className = 'rk-word'; s.textContent = w;
        vis.appendChild(s); if (i < arr.length - 1) vis.appendChild(d.createTextNode(' '));
      });
      p.textContent = ''; p.appendChild(sr); p.appendChild(vis);
      var words = $$('.rk-word', vis), n = words.length;
      if (reduce || !window.Motion || !Motion.scroll) { words.forEach(function (w) { w.style.opacity = 1; }); return; }
      var last = -1;
      Motion.scroll(function (prog) {
        var k = Math.round(prog * 400); if (k === last) return; last = k;
        var lit = prog * (n + 4) - 2;
        for (var i = 0; i < n; i++) {
          var o = Math.min(1, Math.max(0.14, 0.14 + (lit - i) * 0.43));
          words[i].style.opacity = o.toFixed(2);
        }
      }, { target: p, offset: ['start 0.85', 'end 0.45'] });
    });
  }

  /* ---------- 4. Parallaxe légère (grandes images, ordinateur uniquement) ---------- */
  function initParallax() {
    if (reduce || !fine || window.innerWidth < 990 || !window.Motion || !Motion.scroll) return;
    $$('main .spotlight__main').forEach(function (box) {
      var img = box.querySelector('img'); if (!img) return;
      Motion.scroll(function (p) { img.style.translate = '0 ' + ((0.5 - p) * 8).toFixed(2) + '%'; }, { target: box, offset: ['start end', 'end start'] });
    });
  }

  /* ---------- 5. Header : transparent en haut, masqué en descendant, revient en remontant ---------- */
  function initHeader() {
    var header = d.querySelector('.header');
    if (!header) return;
    var drawer = d.querySelector('[data-menu-drawer]');
    var lastY = window.scrollY, ticking = false;
    function update() {
      ticking = false;
      var y = window.scrollY;
      html.classList.toggle('rk-top', y < 12);
      var busy = (drawer && drawer.open) || (fine && header.matches(':hover')) || header.contains(d.activeElement);
      if (y > 180 && y > lastY + 4 && !busy) header.classList.add('is-hidden');
      else if (y < lastY - 4 || y < 180) header.classList.remove('is-hidden');
      lastY = y;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    header.addEventListener('focusin', function () { header.classList.remove('is-hidden'); });
    update();
  }

  /* ---------- 6. Menu mobile : liens en décalé, fermeture rapide ---------- */
  function initMenu() {
    var drawer = d.querySelector('[data-menu-drawer]');
    if (!drawer) return;
    $$('.menu-drawer__list > li, .menu-drawer__cols > li', drawer).forEach(function (li, i) { li.style.setProperty('--i', i); });
    var summary = drawer.querySelector('summary');
    if (!summary || reduce) return;
    summary.addEventListener('click', function (e) {
      if (!drawer.open) return;
      e.preventDefault();
      drawer.classList.add('is-closing');
      setTimeout(function () { drawer.classList.remove('is-closing'); drawer.open = false; }, 200);
    });
  }

  /* ---------- 7. Panier : entrée des articles, suppression douce, confirmation d'ajout ---------- */
  function initCart() {
    var cd = d.querySelector('[data-cart-drawer]');
    var live = d.createElement('p'); live.className = 'visually-hidden'; live.setAttribute('aria-live', 'polite'); d.body.appendChild(live);
    var pending = null;
    d.addEventListener('submit', function (e) {
      if (e.target.matches && e.target.matches('form[action*="/cart/add"]')) {
        pending = { btn: e.submitter || e.target.querySelector('[type="submit"]'), t: Date.now() };
      }
    }, true);
    d.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-cart-change][data-qty="0"]');
      if (rm) { var li = rm.closest('.cd__item'); if (li && !reduce) li.classList.add('is-removing'); }
      var pack = e.target.closest('[data-pack-add]');
      if (pack) pending = { btn: pack, t: Date.now() };
    }, true);
    if (cd) {
      var wasOpen = cd.classList.contains('is-open');
      new MutationObserver(function () {
        var open = cd.classList.contains('is-open');
        if (open && !wasOpen) {
          cd.classList.add('cd--entering');
          setTimeout(function () { cd.classList.remove('cd--entering'); }, 1100);
          if (pending && Date.now() - pending.t < 8000) confirmAdded(pending.btn);
          pending = null;
        }
        wasOpen = open;
      }).observe(cd, { attributes: true, attributeFilter: ['class'] });
      new MutationObserver(function () { initButtons(cd); }).observe(cd, { childList: true });
    }
    function confirmAdded(btn) {
      live.textContent = ''; setTimeout(function () { live.textContent = TXT.added; }, 50);
      if (!btn || reduce) return;
      btn.setAttribute('data-added', '✓ ' + TXT.added);
      btn.classList.add('is-added');
      setTimeout(function () { btn.classList.remove('is-added'); }, 1700);
    }
    // petit rebond du compteur quand il change
    $$('.cart-link').forEach(function (link) {
      new MutationObserver(function () {
        var c = link.querySelector('.cart-link__count');
        if (c && !reduce) play(c, [{ transform: 'scale(1)' }, { transform: 'scale(1.3)' }, { transform: 'scale(1)' }], { duration: 420, easing: EASE.std, fill: 'none' });
      }).observe(link, { childList: true, subtree: true, characterData: true });
    });
  }

  /* ---------- 8. Boutons : le texte roule au survol (ordinateur) ---------- */
  function initButtons(root) {
    if (!fine || reduce) return;
    $$('.button', root).forEach(function (b) {
      if (b.dataset.roll || b.children.length || !b.textContent.trim()) return;
      b.dataset.roll = '1';
      var t = b.textContent.trim();
      b.textContent = '';
      var wrap = d.createElement('span'); wrap.className = 'rk-roll';
      var a = d.createElement('span'); a.className = 'rk-roll__a'; a.textContent = t;
      var c = d.createElement('span'); c.className = 'rk-roll__b'; c.setAttribute('aria-hidden', 'true'); c.textContent = t;
      wrap.appendChild(a); wrap.appendChild(c); b.appendChild(wrap);
    });
  }

  /* ---------- 9. Accordéons fluides ---------- */
  function initAccordions(root) {
    $$('details.accordion__item', root).forEach(function (det) {
      if (det.dataset.acc) return;
      det.dataset.acc = '1';
      var sum = det.querySelector('summary'), body = det.querySelector('.accordion__content');
      if (!sum || !body || reduce) return;
      var anim = null;
      sum.addEventListener('click', function (e) {
        e.preventDefault();
        if (anim) anim.cancel();
        var opening = !det.open;
        if (opening) det.open = true;
        var cs = getComputedStyle(body), h = body.offsetHeight;
        var full = { height: h + 'px', paddingTop: cs.paddingTop, paddingBottom: cs.paddingBottom, opacity: 1 };
        var none = { height: '0px', paddingTop: '0px', paddingBottom: '0px', opacity: 0 };
        body.style.overflow = 'hidden';
        anim = body.animate(opening ? [none, full] : [full, none], opening ? { duration: dur('normal') - 120, easing: EASE.out } : { duration: dur('fast') + 60, easing: EASE.inout });
        anim.onfinish = function () { if (!opening) det.open = false; body.style.overflow = ''; anim = null; };
        anim.oncancel = function () { body.style.overflow = ''; };
      });
    });
  }

  function start() {
    heroIntro();
    scanReveals();
    initStatements();
    initParallax();
    initHeader();
    initMenu();
    initCart();
    initButtons();
    initAccordions();
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start); else start();
  d.addEventListener('shopify:section:load', function (e) { initStatements(e.target); initButtons(e.target); initAccordions(e.target); $$('.rk-hide', e.target).forEach(function (el) { el.classList.remove('rk-hide', 'rk-hide--' + el.dataset.rk); }); });
})();
